<template>
  <el-autocomplete
    v-model="tempValue"
    @select="selectSchool"
    :fetch-suggestions="querySearchAsync"
    :placeholder="placeholder"
    :blur="clearInput"
    ref="complete"
    :clearable="clearable"
    @clear="clearInput"
    v-bind="$attrs"
  >
  </el-autocomplete>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'JmSchoolSearch',
  props: {
    countryId: {
      type: [Number, String],
      default: null,
    },
    countryShId: {
      type: [Number, String],
      default: null,
    },
    countryShMgId: {
      type: [Number, String],
      default: null,
    },
    value: [Object, String],
    clearable: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '请输入学校',
    }
  },
  model: {
    event: 'change',
  },
  data() {
    return {
      tempValue: null,
    };
  },
  computed: {
    showDeleteIcon() {
      return this.tempValue && this.clearable;
    }
  },
  methods: {
    querySearchAsync: _.debounce(function(name, cb) {
      if (!name) {
        cb([]);
        this.selectSchool(null);
        return false;
      }
      this.$http._get({
        url: '/index/api_base/searchSchool',
        data: {
          countryId: this.countryId, // cms中的国家id
          countryShId: this.countryShId, // 院校国家id
          countryShMgId: this.countryShMgId, // 院校国家细分id
          name,
        }
      }).then(({ data }) => {
        const schoolData = Array.isArray(data) ? data : Object.values(data);
        let schools = [];
        schoolData.forEach((item) => {
          item.value = item.sh_name_cn;
          schools.push(item);
        });
        cb(schools);
      });
    }, 300),
    selectSchool(val) {
      this.$emit('change', val);
    },
    clearInput() {
      this.tempValue = '';
      this.selectSchool(null);
    },
    focus() {
      this.$refs.complete.focus();
    }
  },
  watch: {
    value(v) {
      if (!v) {
        this.clearInput();
      } else {
        this.tempValue = v.sh_name_cn;
      }
    }
  },
  mounted() {
    if (this.value) {
      this.tempValue = this.value.sh_name_cn;
    }
  }
};
</script>
